module.exports = __webpack_public_path__ + "images/146_160.jpg";